module.exports = __webpack_public_path__ + "static/media/nth-meeting.aa7cdda4.svg";